export const tr = {
    'long-upload-accept-link': 'Anladım',
    'long-upload-message-addition': 'İşlem tamamlandıktan sonra video eklentisi otomatik olarak oluşturulur.',
    'long-upload-message-creative': 'İşlem tamamlandığında video kreatifi otomatik oluşturulur.',
    'long-upload-message-end': 'Pencereyi kapatmayın.',
    'long-upload-message-start': 'Lütfen bekleyin, video işleniyor.'
};
